const AlertAlarm = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120">
            <path
                d="M37.34 17 16 36.02 18.66 39 40 20 37.34 17ZM25 64a35 35 0 1 1 70 0h4a39 39 0 1 0-39 39v-4a35 35 0 0 1-35-35ZM104 36.02 82.66 17 80 19.99 101.34 39l2.66-2.98Z"
                fill="currentColor"
            />
            <path d="M62 43v25H43v-4h15V43h4ZM84 107V91H68v-4h16V71h4v16h16v4H88v16h-4Z" fill="currentColor" />
        </svg>
    )
}

export default AlertAlarm
